
import type { IBrokerPlugin, IBrokerContext, IBrokerPluginContext } from '@source-digital/sd-app-broker'
import { type ExperienceApp } from './api'

export interface IExperienceAppPlugin extends IBrokerPlugin {
  api?: ExperienceApp
  pluginCtx: IBrokerPluginContext | undefined
  install(ctx: IBrokerPluginContext): Promise<void>
  uninstall(ctx: IBrokerContext): Promise<void>
}

export function experienceAppPlugin (config: {
  api?: ExperienceApp
}): IExperienceAppPlugin {
  return {
    id: '@source-digital/sd-app-plugin-experience-app',
    api: config.api,
    pluginCtx: undefined,
    async install (ctx: IBrokerPluginContext) {
      this.pluginCtx = ctx
      ctx.apis.register(this.id, this.api)
    },
    async uninstall (ctx: IBrokerContext) {
      ctx.apis.unregister(this.id)
    }
  }
}
